import React from "react";
import styled from "styled-components";
import { sanitize } from "dompurify";

const InfoBar = ({
  instructions = [],
}) => {

  return (
    <div>
      {instructions.length > 0 && (
        <React.Fragment>
          <UL>
            {instructions.map((instruction) => (
              <li dangerouslySetInnerHTML={{ __html: sanitize(instruction) }} />
            ))}
          </UL>
        </React.Fragment>
      )}
    </div>
  );
};

const UL = styled.ul`
  padding: 0 0 0 20px;
`;

export default React.memo(InfoBar);
